export default __webpack_public_path__ + "static/media/escudo-ancho.f1970c0c.svg";